import {
    Grid,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    TextField,
    Tooltip,
    IconButton,
    Paper,
    Autocomplete
} from "@mui/material"
import { AddCircleOutline, Delete } from "@mui/icons-material"
import { useEffect, useMemo } from "react"
import { formatNumber } from "../ApiServices";

export default function CuerpoEditar(props) {

    const handleAddLinea = () => {
        props.propiedades.setdatosCuerpo((prevState) => [
            ...prevState,
            {
                subtotal: "",
                subtotal_iva: "0,00",
                id_porcentajeiva: props.propiedades.comprobanteSelected && props.propiedades.comprobanteSelected.id_tipo_comprobante === 11 ? 4 : 1,
                detalle_productos: null,
                uuid_comprobante: props.propiedades.datos.uuid_comprobante,
                usuario: localStorage.getItem("user"),
                id_imputacion: null,
                monto_iva: "0,00"
            },
        ])
    };

    const handleInputChange = (index, field, value) => {
        props.propiedades.setdatosCuerpo((prevValues) => {
            const updatedValues = [...prevValues];
            // Aplicamos formatNumber al subtotal mientras escriben
            const finalValue = field === "subtotal" ? formatNumber(value) : value;

            const updatedItem = { ...updatedValues[index], [field]: finalValue };

            if (field === "subtotal") {
                const { iva, total } = calculateSubtotalIva(finalValue, updatedItem.id_porcentajeiva);
                updatedItem.monto_iva = iva;
                updatedItem.subtotal_iva = total;
            }

            updatedValues[index] = updatedItem;
            return updatedValues;
        });
    };

    const handlePorcentajeIvaChange = (index, id_porcentajeiva) => {
        props.propiedades.setdatosCuerpo((prevValues) => {
            const updatedValues = [...prevValues];
            const updatedItem = { ...updatedValues[index], id_porcentajeiva };

            // Recalculamos usando el subtotal actual
            const { iva, total } = calculateSubtotalIva(updatedItem.subtotal, id_porcentajeiva);

            updatedItem.monto_iva = iva;
            updatedItem.subtotal_iva = total;

            updatedValues[index] = updatedItem;
            return updatedValues;
        });
    };

    const deshacerLinea = (index) => {
    // if (formValues.length > 1) {
    if (props.propiedades.datosCuerpo.length > 1) {
      const values = [...props.propiedades.datosCuerpo]
      values.splice(index, 1)
      // setFormValues(values)
      props.propiedades.setdatosCuerpo(values)
    }
  }
    /* ---------------------------- HELPERS ----------------------------- */

    const calculateSubtotalIva = (subtotal, id_porcentajeiva) => {
        // Si subtotal es "26.307.118,87", esto lo deja en 26307118.87
        const subtotalok = typeof subtotal === 'string'
            ? parseFloat(subtotal.replace(/\./g, "").replace(",", ".")) || 0
            : subtotal || 0;

        const porcentajeItem = props.propiedades.valorPorcentajes.find(
            (item) => item.idporcentaje_iva === id_porcentajeiva
        );

        const valor = porcentajeItem ? parseFloat(porcentajeItem.valor) : 1;

        const iva = subtotalok * (valor - 1);
        const total = subtotalok * valor;

        // Retornamos strings ya listos para mostrar
        return {
            iva: formatNumber(iva.toFixed(2).replace(".", ",")),
            total: formatNumber(total.toFixed(2).replace(".", ","))
        };
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#1f618d",
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#1f618d",
        },
    };

    const combinedOptions = useMemo(() => {
        // Si la lista general no cargó, devolvemos vacío
        if (!props.propiedades.imputaciones) return [];

        // IMPORTANTE: Aseguramos que sea array con || []
        const provList = props.propiedades.imputacionesProveedor || [];

        return props.propiedades.imputaciones.map(imp => {
            // Usamos optional chaining por si acaso
            const esDelProveedor = provList.some(p => p?.idimputacion === imp?.idimputacion);

            return {
                ...imp,
                category: esDelProveedor ? "Imputaciones asociadas" : "Otras "
            };
        }).sort((a, b) => (a.category === "Imputaciones asociadas" ? -1 : 1));
    }, [props.propiedades.imputaciones, props.propiedades.imputacionesProveedor]);




    return (
        <div>
            <Paper
                elevation={3}
                sx={{
                    background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
                    mt: 1,
                    p: 3,
                    borderRadius: 4,
                    borderLeft: "6px solid #1f618d",
                }}>

                {props.propiedades.datosCuerpo && props.propiedades.datosCuerpo.map((item, index) => {
                    const esElUltimoVisible = index === props.propiedades.datosCuerpo.length - 1;

                    return (
                        <Grid
                            container
                            spacing={1}
                            alignItems="center"
                            mt={1}
                            key={item.uuid_linea || `linea-${index}`}
                        >
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth
                                    required
                                    sx={style}
                                    label="Descripción"
                                    value={item.detalle_productos || ""}
                                    onChange={(e) => handleInputChange(index, "detalle_productos", e.target.value)}
                                    size="small"
                                    focused
                                />
                            </Grid>

                            <Grid item xs={12} sm={1.5}>
                                <TextField
                                    fullWidth
                                    sx={style}
                                    label="Neto"
                                    value={
                                        item.subtotal !== undefined && item.subtotal !== null
                                            ? (typeof item.subtotal === 'number'
                                                ? formatNumber(item.subtotal.toFixed(2).replace(".", ","))
                                                : formatNumber(item.subtotal))
                                            : ""
                                    }
                                    size="small"
                                    focused
                                    autoCapitalize="off"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleInputChange(index, "subtotal", value);
                                    }}
                                    onBlur={(e) => {
                                        const valorFormateado = formatNumber(e.target.value);
                                        handleInputChange(index, "subtotal", valorFormateado);
                                    }}
                                    onKeyPress={(event) => {
                                        const { value } = event.target;
                                        // Solo permitimos números y una sola coma
                                        if (!/[\d,]/.test(event.key)) event.preventDefault();
                                        if (event.key === "," && value.includes(",")) event.preventDefault();
                                    }}
                                />
                            </Grid>

                            {/* 3. Selección de IVA % */}
                            <Grid item xs={12} sm={1.7}>
                                <FormControl fullWidth size="small" focused sx={style}>
                                    <InputLabel>IVA %</InputLabel>
                                    <Select
                                        value={item.id_porcentajeiva || ""}
                                        onChange={(e) => handlePorcentajeIvaChange(index, e.target.value)}
                                        label="IVA %"
                                    >
                                        {props.propiedades.valorPorcentajes.map(({ idporcentaje_iva, descripcion }) => (
                                            <MenuItem key={idporcentaje_iva} value={idporcentaje_iva}>
                                                {descripcion}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* 4. Monto IVA (Calculado y ReadOnly) */}
                            <Grid item xs={12} sm={1.5}>
                                <TextField
                                    fullWidth
                                    sx={style}
                                    label="Monto IVA"
                                    value={
                                        item.monto_iva !== undefined && item.monto_iva !== null
                                            ? (typeof item.monto_iva === 'number'
                                                ? formatNumber(item.monto_iva.toFixed(2).replace(".", ","))
                                                : formatNumber(item.monto_iva))
                                            : ""
                                    }
                                    size="small"
                                    focused
                                    inputProps={{ readOnly: true }} // El usuario no lo toca, se calcula solo
                                />
                            </Grid>

                            {/* 5. Imputación (Autocomplete con categorías) */}
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    size="small"
                                    options={combinedOptions}
                                    groupBy={(option) => option.category}
                                    // Buscamos el valor en las opciones para que el Autocomplete lo muestre correctamente
                                    value={combinedOptions.find((opt) => opt.idimputacion === item.id_imputacion) || null}
                                    noOptionsText="No encontrado"
                                    onChange={(event, newValue) => {
                                        // --- USAMOS INDEX DIRECTO ---
                                        handleInputChange(index, "id_imputacion", newValue ? newValue.idimputacion : "");

                                        // Lógica para recordar imputación nueva del proveedor
                                        if (newValue) {
                                            const existe = props.propiedades.imputacionesProveedor?.some(
                                                (p) => p.idimputacion === newValue.idimputacion
                                            );

                                            // Si no existe y el proveedor es de padrón 0, avisamos que queremos guardar
                                            if (!existe && props.propiedades.proveedorSelected?.padron === 0) {
                                                props.propiedades.setGuardarImputacProveedor(true);
                                            }
                                        }
                                    }}
                                    getOptionLabel={(option) => option.descripcion || ""}
                                    isOptionEqualToValue={(option, value) => option.idimputacion === value.idimputacion}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Imputado a" required focused sx={style} />
                                    )}
                                />
                            </Grid>

                            {/* 6. Acciones */}
                            <Grid item xs={12} sm={1.3} sx={{ display: "flex", justifyContent: "flex-start" }}>
                                <Tooltip title="Eliminar">
                                    <span>
                                        <IconButton
                                            onClick={() => deshacerLinea(index)} // Ahora el index es directo y no falla
                                            disabled={props.propiedades.datosCuerpo.length === 1}
                                            color="error"
                                        >
                                            <Delete fontSize="small" />
                                        </IconButton>
                                    </span>
                                </Tooltip>

                                <Tooltip title="Nueva Línea">
                                    <span>
                                        {esElUltimoVisible && (
                                            <IconButton
                                                onClick={handleAddLinea}
                                                sx={{
                                                    color: "#1f618d",
                                                    visibility: esElUltimoVisible ? "visible" : "hidden",
                                                }}
                                                disabled={!item.subtotal || item.subtotal === "0,00"}
                                            >
                                                <AddCircleOutline fontSize="small" />
                                            </IconButton>
                                        )}
                                    </span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    );
                })
                }
            </Paper>
        </div>
    )
}